export default {
  methods: {
    generateUrlQuery(params) {
      return {query: Object.assign({}, this.$route.query, params)};
    }
  },
};
